import React, { useState } from "react";
import { Toast } from "react-bootstrap";
interface AlertToastProps {
  alerts: Data.Alert[];
  stacked?: boolean;
}

interface AlertToastTracking {
  alertId: number;
  show: boolean;
}

export default function AlertToasts(props: AlertToastProps) {
  const { alerts } = props;

  const [show, setShow] = useState<AlertToastTracking[]>(
    alerts.map((_, index) => ({
      alertId: index,
      show: true,
    }))
  );

  const dismiss = (alertId: number) => {
    const currentItem = show.find((item) => item.alertId === alertId);
    if (!currentItem) return;
    currentItem.show = false;
    setShow([...show.filter((item) => item.alertId !== alertId), currentItem]);
  };

  return alerts.length ? (
    <div className="d-flex flex-sm-row flex-column w-100">
      {alerts.map((alert, index) => (
        <Toast
          key={index}
          style={{ minWidth: "350px", minHeight: "200px" }}
          show={show.find((item) => item.alertId === index)?.show ?? true}
          onClose={() => dismiss(index)}
          className={`toast-${alert.level} mr-3`}
        >
          <Toast.Header>
            <strong className="mr-auto">
              {alert.level.replace(/^./, alert.level[0].toUpperCase())}
            </strong>
            <small>{alert.posted_date}</small>
          </Toast.Header>
          <Toast.Body>{alert.alert}</Toast.Body>
        </Toast>
      ))}
    </div>
  ) : null;
}
